import React from 'react';

const NotificationBanner = ({ children }) => (
  <div className="bg-violet-500/10 border border-violet-400/30 text-violet-100 rounded-2xl px-4 py-3 text-sm">
    {children}
  </div>
);

const ErrorBanner = ({ message, onRetry, onDismiss }) => (
  <div className="bg-amber-400/90 text-gray-900 border border-amber-200 rounded-2xl px-4 py-3 text-sm space-y-3 shadow-lg">
    <p className="leading-snug font-semibold">{message}</p>
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onRetry}
        className="px-3 py-1.5 rounded-xl font-semibold text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 shadow"
      >
        Retry extraction
      </button>
      <button
        type="button"
        onClick={onDismiss}
        className="px-3 py-1.5 rounded-xl font-semibold text-gray-900 bg-amber-200 hover:bg-amber-100 shadow"
      >
        Dismiss
      </button>
    </div>
  </div>
);

export { ErrorBanner, NotificationBanner };

